export default function PageHero({ title, subtitle, children }) {
  return (
    <section className="rounded-3xl border border-white/60 bg-gradient-to-b from-pink-50 to-white p-6 shadow-2xl sm:p-8 lg:p-10">
      <h1 className="text-3xl font-bold tracking-tight text-slate-800 sm:text-4xl lg:text-5xl">{title}</h1>
      {subtitle ? <p className="mt-3 max-w-3xl text-slate-600 sm:text-lg">{subtitle}</p> : null}
      {children ? <div className="mt-5">{children}</div> : null}
    </section>
  );
}
